import { fleetManagementApi } from "../api";

const VEHICLE_CATEGORY_ENDPOINT = "/vehicle-categories";

export const getVehicleCategories = async () => {
  const response = await fleetManagementApi.get(VEHICLE_CATEGORY_ENDPOINT);
  return response;
};

export const getVehicleCategoryById = async (categoryId) => {
  const response = await fleetManagementApi.get(`${VEHICLE_CATEGORY_ENDPOINT}/${categoryId}`);
  return response;
};

export const createVehicleCategory = async (categoryData) => {
  const response = await fleetManagementApi.post(VEHICLE_CATEGORY_ENDPOINT, categoryData);
  return response;
};

export const updateVehicleCategory = async (categoryId, categoryData) => {
  const response = await fleetManagementApi.put(`${VEHICLE_CATEGORY_ENDPOINT}/${categoryId}`, categoryData);
  return response;
};

export const deleteVehicleCategory = async (categoryId) => {
  const response = await fleetManagementApi.delete(`${VEHICLE_CATEGORY_ENDPOINT}/${categoryId}`);
  return response;
};
